import React from 'react';
import { MapPin, Clock, Phone } from 'lucide-react';
export function Locations() {
  const locations = [{
    name: 'Howell Showroom & Main Service Center',
    address: '222 W Grand River Ave, Howell, MI 48843',
    phone: '517-545-7772',
    phoneLink: '5175457772'
  }, {
    name: 'Ann Arbor Satellite Office',
    address: '2723 South State St, Suite 150, Ann Arbor, MI 48104',
    phone: '734-887-6556',
    phoneLink: '7348876556'
  }, {
    name: 'Novi Satellite Office',
    address: '39555 Orchard Hill Place, Suite 600, Novi, MI 48375',
    phone: '248-924-9899',
    phoneLink: '2489249899'
  }];
  return <section className="py-20 bg-glass" data-id="element-1424" data-mp="2980pvux8t61w">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-1425" data-mp="2485w9jm322d5">
        <div className="text-center max-w-3xl mx-auto mb-16 anim-on-scroll" data-id="element-1426" data-mp="2i6vsyy4zq00z">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-6 tracking-normal" data-id="element-1427" data-mp="2i75o104w6xdj">
            Glass Shower Doors Near Howell, Ann Arbor, Novi & Southeast Michigan
          </h2>
          <p className="text-lg text-gray-600" data-id="element-1428" data-mp="23v68b6ep9lt1">
            Kosin's Glass installs custom glass shower doors and enclosures
            across Southeast Michigan, including Howell, Ann Arbor, Novi,
            Brighton, Fenton, Grand Blanc, Hartland, Fowlerville, Northville,
            Lansing, East Lansing, Webberville, Williamston and nearby
            communities.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-1429" data-mp="2mrxx1vd0gt4h">
          {locations.map((loc, i) => <div key={i} className="bg-white p-8 rounded-lg shadow-sm border border-blue-50 text-center scroll-fade-up" style={{
          animationDelay: `${i * 0.1}s`
        }} data-id="element-1430" data-mp="2rpzhajm6ayhj" data-mpi={i}>
              <MapPin className="w-8 h-8 text-primary mx-auto mb-4" data-id="element-1431" data-mp="36gq8pqjurvk4" />
              <h3 className="text-xl font-bold text-navy mb-3" data-id="element-1432" data-mp="36edjqtfogkxk">{loc.name}</h3>
              <p className="text-gray-600 mb-4" data-id="element-1433" data-mp="3ail5chqu9krk">{loc.address}</p>
              <a href={`tel:${loc.phoneLink}`} className="inline-flex items-center gap-2 text-primary font-bold hover:text-primary-hover transition-colors" data-id="element-1434" data-mp="1bcih0lmirobl">
                <Phone className="w-4 h-4" data-id="element-1435" data-mp="1k5vkghi7m8bx" />
                {loc.phone}
              </a>
            </div>)}
        </div>
        <div className="max-w-md mx-auto bg-white p-6 rounded-lg shadow-sm border border-blue-50 flex items-start gap-4 anim-on-scroll" data-id="element-1436" data-mp="1fdluj1h3h89n">
          <Clock className="w-6 h-6 text-primary shrink-0 mt-1" data-id="element-1437" data-mp="1p4yn5vapw2gq" />
          <div data-id="element-1438" data-mp="1p4gf81eozzsz">
            <h4 className="font-bold text-navy mb-2" data-id="element-1439" data-mp="1p72ms11l2fb7">Hours of Operation</h4>
            <ul className="text-gray-600 space-y-1 text-sm" data-id="element-1440" data-mp="233ok9axje253">
              <li className="flex justify-between" data-id="element-1441" data-mp="1z2mjuqrvvk1j">
                <span data-id="element-1442" data-mp="1z11o4xtu1v23">Monday–Friday:</span> <span data-id="element-1443" data-mp="8q6wpnx4t5a2">8:00 a.m. to 5:00 p.m.</span>
              </li>
              <li className="flex justify-between" data-id="element-1444" data-mp="8sjbxtbi91jf">
                <span data-id="element-1445" data-mp="4pwpk7xls8tm">Saturday:</span> <span data-id="element-1446" data-mp="4qfxcvtjhgtx">9:00 a.m. to 3:00 p.m.</span>
              </li>
              <li className="flex justify-between" data-id="element-1447" data-mp="3qq2fj70kncsi">
                <span data-id="element-1448" data-mp="3qsf3c0t0ghdh">Sunday:</span> <span data-id="element-1449" data-mp="3urnz1b7m2pbo">Closed</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}